import './ConfirmModal.scss';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { cloneElement, ReactElement, ReactNode, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  className?: string;
  openButton: ReactElement;
  message?: ReactNode;
  title?: ReactNode;
  onOk?: Function;
  onCancel?: Function;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const { t } = useTranslation();
  const { className, openButton, message, title, onOk, onCancel } = props;
  const [open, setOpen] = useState(openButton ? false : true);
  const handleOk = useCallback(() => {
    onOk?.();
    setOpen(false);
  }, [onOk]);
  const handleCancel = useCallback(() => {
    onCancel?.();
    setOpen(false);
  }, [onCancel]);
  const handleOpen = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);

    return;
  }, []);
  const openButtonWithOnClick = useMemo(
    () => (openButton ? cloneElement(openButton, { onClick: handleOpen }) : <></>),
    [openButton, handleOpen],
  );

  return (
    <>
      {openButtonWithOnClick}
      <Modal
        className={`ConfirmModal ${className}`}
        title={
          <div className="ConfirmModalTitle">
            <InfoCircleOutlined className="ConfirmModalIcon" />
            {title}
          </div>
        }
        open={open}
        onCancel={handleCancel}
        onOk={handleOk}
        okText={t('Aceptar')}
        cancelText={t('Cancelar')}
        closable={false}
        maskClosable={false}>
        <div className="ConfirmModalContent">{message}</div>
      </Modal>
    </>
  );
};

export default ConfirmModal;
